import { render, staticRenderFns } from "./SktSpecial.vue?vue&type=template&id=4b0b513e&scoped=true"
import script from "./SktSpecial.vue?vue&type=script&lang=js"
export * from "./SktSpecial.vue?vue&type=script&lang=js"
import style0 from "./SktSpecial.vue?vue&type=style&index=0&id=4b0b513e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b513e",
  null
  
)

export default component.exports